import { TicketEditDialogComponent } from "@app/view/planning/ticket-edit-dialog/ticket-edit-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import {
  AssignmentModel,
  EventDragConfig,
  EventModel,
  Scheduler
} from "@bryntum/scheduler-thin";
import { Injectable, inject } from "@angular/core";
import { TicketStreamingStore } from "@app/services/streaming/ticket-streaming-store";
import { Ticket_DetailProjection } from "@app/models/rest/ticket";
import { TicketStatus } from "@app/models/enums/ticket-status.enum";

@Injectable({
  providedIn: "root"
})
export class TicketDrag {
  dialog = inject(MatDialog);
  protected ticketStore = inject(TicketStreamingStore);

  public config: Partial<EventDragConfig> = {
    tooltipTemplate: this.dragTipTemplate.bind(this),
    constrainDragToResource: false
  };

  public dragTipTemplate(data: {
    eventRecord;
    valid;
    startText;
    startClockHtml;
    dragData;
  }) {
    console.log("dragData", data);
    if (!data.valid) {
      return "Invalid";
    }
    if (
      data.dragData.newResource.get("id") !== data.eventRecord.get("resourceId")
    ) {
      return "Lock Resource And Time";
    }
    return "Lock Time";
  }

  public eventDragAbort(data: {
    source;
    assignmentRecords;
    eventRecords;
    context;
  }) {
    console.log("drag aborted", data);
    data.eventRecords.forEach((eventRecord) => {
      eventRecord.setStartEndDate(
        eventRecord.get("enrouteTime"),
        eventRecord.get("completedTime")
      );
    });
  }

  public beforeEventDropFinalize(data: {
    context: {
      async: boolean;
      valid: boolean;
      startDate;
      eventRecords: EventModel[];
      finalize: Function;
      newResource;
    };
  }) {
    console.log("finalizing drop", data);
    data.context.async = true;
    setTimeout(() => {
      const dialogRef = this.dialog.open(TicketEditDialogComponent, {
        width: "400px",
        data: {
          ticketId: data.context.eventRecords[0].get("id"),
          newForceStartTime: data.context.startDate,
          oldResourceId: data.context.eventRecords[0].get("resourceId"),
          newResourceId: data.context.newResource.get("id")
        },
        panelClass: "toolbar-popup-dialog"
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result && result.refreshTicket) {
          console.log("Refreshing ticket after error:", result.refreshTicket);
          this.ticketStore
            .loadSingleProjection(
              Ticket_DetailProjection,
              result.refreshTicket,
              "detail"
            )
            .then((refreshedTicket: Ticket_DetailProjection) => {
              const eventRecord = data.context.eventRecords[0];
              const resolvedResourceId =
                refreshedTicket.lockToResource?.id ||
                (refreshedTicket.resourceAvailability as any)?.resource?.id ||
                null;
              eventRecord.set("resourceId", resolvedResourceId);
              eventRecord.set("lockToResource", refreshedTicket.lockToResource);
              if (refreshedTicket.resourceAvailability) {
                eventRecord.set(
                  "resourceAvailability",
                  refreshedTicket.resourceAvailability
                );
              }
            })
            .catch((e) => {
              console.warn("Failed to refresh ticket after error", e);
            });
        }
      });

      data.context.finalize(false);
    }, 100);
  }

  public eventDrop(data: { eventRecords: EventModel[] }) {
    console.log("drag end");
    console.log(data);
    return false;
  }

  public beforeEventDrag(data: { eventRecord: EventModel }) {
    console.log("before event drag");
    return data.eventRecord.get("ticketStatus") === TicketStatus.PLANNING;
  }

  public eventDragStart(data: {
    source: Scheduler;
    eventRecords: EventModel[];
    assignmentRecords: AssignmentModel[];
    context: any;
  }) {
    console.log("drag start", data);
  }
}
